import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { useProjectAddress } from "../../../shell/project";
import {
  type Operation,
  worldsOperationId,
} from "../../../workspaces/worlds/api";
import { WorldsPage } from "../../../workspaces/worlds/pages/WorldsPage";
import {
  parseWorldsFilters,
  type WorldsFilters,
} from "../../../workspaces/worlds/search";

export const Route = createFileRoute(
  "/_console/p/$org/$project/build-worlds/create",
)({
  validateSearch: parseWorldsFilters,
  component: CreateWorldAssetRoute,
});

function CreateWorldAssetRoute() {
  const projectAddress = useProjectAddress();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const onStateChange = useCallback(
    (patch: Partial<WorldsFilters>, options?: { readonly replace?: boolean }) =>
      void navigate({
        replace: options?.replace,
        search: (current) => ({ ...current, ...patch }),
      }),
    [navigate],
  );
  const onCreateAccepted = useCallback(
    (accepted: Operation) =>
      void navigate({
        to: "/p/$org/$project/simulate",
        params: projectAddress,
        replace: true,
        search: (current) => ({
          ...current,
          operation: worldsOperationId(accepted),
        }),
      }),
    [navigate, projectAddress],
  );
  return (
    <WorldsPage
      state={search}
      onStateChange={onStateChange}
      createOpen
      onCreateOpenChange={(open) => {
        if (!open) {
          void navigate({
            to: "/p/$org/$project/simulate",
            params: projectAddress,
            replace: true,
            search: (current) => current,
          });
        }
      }}
      onCreateAccepted={onCreateAccepted}
      onOpenDraft={(draftId, revision) =>
        void navigate({
          to: "/p/$org/$project/build-worlds/drafts/$draftId",
          params: { ...projectAddress, draftId },
          search: { revision },
        })
      }
    />
  );
}
